import HealthsFilter from './HealthsFilter';

export default HealthsFilter;



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/HealthsFilter/index.js